import { Messages } from '~src/codegen/Localize';
import { OrderKeys } from '~src/spacesPlatform/models/OrderKeys';
import { SortOptions } from '~src/spacesPlatform/models/sort/CommonSortOptions';
import { Order } from '~src/spacesPlatform/models/sort/Order';
import { OptionsDictionary } from '~src/spacesPlatform/models/sort/SortOptionDefinitions';
import { IOrderClause } from '~src/spacesPlatform/serverApi/types/IOrderClause';
import { viewSortOptions, workbookNameSortOption } from '~src/views/models/sort/ViewSortOptions';

export const recentsSpaceDefaultSortOrder: IOrderClause[] = [Order.desc(OrderKeys.lastAccessedAt)];

export const recentsSortOptions: OptionsDictionary = {
    'name': SortOptions.name,
    'workbook': workbookNameSortOption,
    'lastAccessedAt': {
      id: 'lastAccessedAt',
      getMenuItemDisplayValue: Messages.sortLastAccessedAt,
      subSortOptions: {
        'desc': {
          id: 'lastAccessedAt.desc',
          field: OrderKeys.lastAccessedAt,
          getMenuItemDisplayValue: Messages.sortByNewest,
          getButtonDisplayValue: Messages.sortLastAccessedAtNewest,
          ascending: false,
          toOrderClauseArray: () => [Order.desc(OrderKeys.lastAccessedAt)]
        },
        'asc': {
          id: 'lastAccessedAt.asc',
          field: OrderKeys.lastAccessedAt,
          getMenuItemDisplayValue: Messages.sortByOldest,
          getButtonDisplayValue: Messages.sortLastAccessedAtOldest,
          ascending: true,
          toOrderClauseArray: () => [Order.asc(OrderKeys.lastAccessedAt)]
        }
      }
    },
    'containerName': SortOptions.containerName,
    'owner': SortOptions.owner,
};

// required because Metrics can be disabled
export const recentViewsOptions: OptionsDictionary = {
  ...viewSortOptions,
  'lastAccessedAt': {
    id: 'lastAccessedAt',
    getMenuItemDisplayValue: Messages.sortLastAccessedAt,
    subSortOptions: {
      'desc': {
        id: 'lastAccessedAt.desc',
        field: OrderKeys.lastAccessedAt,
        getMenuItemDisplayValue: Messages.sortByNewest,
        getButtonDisplayValue: Messages.sortLastAccessedAtNewest,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.lastAccessedAt)]
      },
      'asc': {
        id: 'lastAccessedAt.asc',
        field: OrderKeys.lastAccessedAt,
        getMenuItemDisplayValue: Messages.sortByOldest,
        getButtonDisplayValue: Messages.sortLastAccessedAtOldest,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.lastAccessedAt)]
      }
    }
  }
};
